// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2CFHx","bigColWidth":"Table_bigColWidth__3RPiU","biggerColWidth":"Table_biggerColWidth__2TxtA","row":"Table_row__3_QJn","col":"Table_col__3a0mG"};